import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Stack,
  Alert,
  Typography,
} from '@mui/material';
import { settingsService } from '../../services/settings.service';
import toast from 'react-hot-toast';

export const SecuritySettings: React.FC = () => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [isChanging, setIsChanging] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [field]: e.target.value });
    setError('');
  };

  const handleChangePassword = async () => {
    if (!formData.newPassword || !formData.confirmPassword) {
      setError('Please fill in all fields');
      return;
    }

    if (formData.newPassword.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setIsChanging(true);
    try {
      await settingsService.changePassword(formData.newPassword);
      toast.success('Password changed successfully');
      setFormData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
    } catch (error: any) {
      setError(error.message || 'Failed to change password');
      toast.error('Failed to change password');
    } finally {
      setIsChanging(false);
    }
  };

  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        Change Password
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
        Update your password to keep your account secure
      </Typography>

      {error && (
        <Alert severity='error' sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Stack spacing={3} sx={{ maxWidth: 400 }}>
        <TextField
          fullWidth
          type='password'
          label='New Password'
          value={formData.newPassword}
          onChange={handleChange('newPassword')}
          helperText='Must be at least 8 characters'
        />
        <TextField
          fullWidth
          type='password'
          label='Confirm New Password'
          value={formData.confirmPassword}
          onChange={handleChange('confirmPassword')}
        />
        <Box>
          <Button
            variant='contained'
            onClick={handleChangePassword}
            disabled={isChanging}
          >
            {isChanging ? 'Changing...' : 'Change Password'}
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};